import React from 'react';
import RpSwitchFilter from 'components/commons/RpSwitchFilter';
import useFilterStore from 'zustandStore/useFilterStore';

const SwitchFilter = React.memo(function SwitchFilter(props) {
    const filter = useFilterStore(state => state.filters?.[props.comparableType]?.[props.attr]);
    const setFilters = useFilterStore(state => state.setFilters);

    return (
        <RpSwitchFilter
            onChange={val => setFilters(props.comparableType, {[props.attr]: val})}
            label={props.label}
            value={filter}
            {...props}
        />
    );
});

export default SwitchFilter;